module.exports = __webpack_public_path__ + "img/nabl_main2.732bf4aa.jpg";